(function (window, document) {
  'use strict';

  var apiKey = 'NcbBulletinSignupHydration';
  var shellSelector = '[data-bulletin-signup-shell][data-klaviyo-form-id]';
  var fallbackSelector = '[data-bulletin-signup-fallback]';
  var initializedShells = new WeakSet();
  var initializedFallbackForms = new WeakSet();
  var clientSubscriptionRevision = '2026-01-15';

  if (window[apiKey]) {
    window[apiKey].scan();
    return;
  }

  function mountSelector(formId) {
    var safeFormId = String(formId || '').trim();
    if (!/^[A-Za-z0-9_-]+$/.test(safeFormId)) return '';

    return '.klaviyo-form-' + safeFormId;
  }

  function sync(shell) {
    if (!shell || !shell.matches(shellSelector)) return;

    var formId = shell.getAttribute('data-klaviyo-form-id');
    var fallback = shell.querySelector(fallbackSelector);
    if (!fallback) return;

    var expectedMountSelector = mountSelector(formId);
    var expectedMount = expectedMountSelector ? shell.querySelector(expectedMountSelector) : null;
    var isHydrated = Boolean(expectedMount && expectedMount.querySelector('form'));
    fallback.hidden = isHydrated;
    fallback.style.display = isHydrated ? 'none' : '';
  }

  function setFallbackStatus(form, message) {
    var status = form.closest('[data-bulletin-signup-fallback]');
    if (!status) return;

    var statusMessage = status.querySelector('[data-klaviyo-fallback-status]');
    if (!statusMessage) return;

    statusMessage.hidden = false;
    statusMessage.textContent = message;
  }

  function mirrorShopifyCustomer(form) {
    var action = form.getAttribute('action') || '/contact';

    return fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).catch(function () {
      return null;
    });
  }

  function subscribeToKlaviyo(form, shell) {
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var listId = shell.getAttribute('data-klaviyo-list-id');
    var publicApiKey = shell.getAttribute('data-klaviyo-public-api-key');

    if (!email || !listId || !publicApiKey) {
      return Promise.reject(new Error('The Bulletin signup is not configured.'));
    }

    var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicApiKey);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'The Cottage Bulletin footer fallback',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        revision: clientSubscriptionRevision
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo rejected the Bulletin subscription.');
      return mirrorShopifyCustomer(form);
    });
  }

  function notifyBulletinSubmitted(shell) {
    var owner = shell && shell.closest ? shell.closest('[data-bulletin-signup]') : null;
    var location = owner && owner.getAttribute ? owner.getAttribute('data-bulletin-signup-location') : '';
    try {
      document.dispatchEvent(new CustomEvent('ncb:bulletin-signup-submitted', {
        detail: { signupLocation: location || 'unknown' }
      }));
    } catch (error) {}
  }

  function handleFallbackSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches('.footer-block__bulletin-fallback-form')) return;

    event.preventDefault();

    var shell = form.closest(shellSelector);
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var submitButton = form.querySelector('button[type="submit"]');
    if (!shell || !emailInput || !emailInput.reportValidity()) return;

    if (submitButton) submitButton.disabled = true;
    setFallbackStatus(form, 'Adding you to The Cottage Bulletin...');

    subscribeToKlaviyo(form, shell)
      .then(function () {
        setFallbackStatus(form, 'Check your inbox to confirm your Cottage Bulletin subscription.');
        form.reset();
        notifyBulletinSubmitted(shell);
      })
      .catch(function () {
        setFallbackStatus(form, 'We could not sign you up just now. Please try again.');
        if (submitButton) submitButton.disabled = false;
      });
  }

  function initializeFallbackForm(shell) {
    var fallback = shell.querySelector(fallbackSelector);
    var form = fallback && fallback.querySelector('.footer-block__bulletin-fallback-form');
    if (!form || initializedFallbackForms.has(form)) return;

    initializedFallbackForms.add(form);
    form.addEventListener('submit', handleFallbackSubmit);
  }

  function scan(scope) {
    var root = scope || document;
    if (root.matches && root.matches(shellSelector)) initialize(root);

    var shells = root.querySelectorAll(shellSelector);
    for (var index = 0; index < shells.length; index += 1) {
      initialize(shells[index]);
    }
  }

  function initialize(shell) {
    sync(shell);
    initializeFallbackForm(shell);
    if (initializedShells.has(shell)) return;

    initializedShells.add(shell);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        sync(shell);
      }).observe(shell, { childList: true, subtree: true });
    }
  }

  function handleRetry(event) {
    var retry = event.target.closest && event.target.closest('[data-bulletin-signup-retry]');
    if (!retry) return;

    event.preventDefault();
    window.location.reload();
  }

  window[apiKey] = { scan: scan, sync: sync };
  document.addEventListener('click', handleRetry);
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  scan();
})(window, document);
